import { downgradeComponent, downgradeInjectable } from "@angular/upgrade/static";
import { VTableService } from "@app/directives/_layout/v-table/_services/v-table.service";
import * as angular from "angular";
import { CheckboxCell } from "./_components/cells/checkbox-cell/checkbox-cell.component";
import { EnumCellComponent } from "./_components/cells/enum-cell/v-enum-cell.component";
import { VTableHeader } from "./_components/cells/header/v-table-header.component";
import { PercentageBarCellComponent } from "./_components/cells/percentage-bar/percentage-bar-cell.component";
import { RagCellComponent } from "./_components/cells/rag-cell/rag-cell.component";
import { StackedCell } from "./_components/cells/stacked-cell/stacked-cell.component";
import { DateCell } from "./_components/cells/stacked-date/date-cell.component";
import { StatusCell } from "./_components/cells/status-cell/status-cell.component";
import { VTableCell } from "./_components/cells/v-table-cell.component";
import { VTableActionsComponent } from "./_components/v-table-actions/v-table-actions.component";
import { VTableLayoutContainer } from "./_components/v-table-layout-container/v-table-layout-container.component";
import { VTableComponent } from "./_components/v-table.component";
import { TableSummaryBox } from "./_components/visualisations/table-summary-box/table-summary-box.component";

angular
    .module("app.vtable.directives", [])
    .directive("vTableLayoutContainer", downgradeComponent({ component: VTableLayoutContainer }))
    .directive("vTable", downgradeComponent({ component: VTableComponent }))
    .directive("vTableHeader", downgradeComponent({ component: VTableHeader }))
    .directive("vTableCell", downgradeComponent({ component: VTableCell }))
    .directive("stackedCell", downgradeComponent({ component: StackedCell }))
    .directive("dateCell", downgradeComponent({ component: DateCell }))
    .directive("checkboxCell", downgradeComponent({ component: CheckboxCell }))
    .directive("statusCell", downgradeComponent({ component: StatusCell }))
    .directive("enumCell", downgradeComponent({ component: EnumCellComponent }))
    .directive("vTableActions", downgradeComponent({ component: VTableActionsComponent }))
    .directive("tableSummaryBox", downgradeComponent({ component: TableSummaryBox }))
    .directive("ragCell", downgradeComponent({ component: RagCellComponent }))
    .directive("percentageBarCell", downgradeComponent({ component: PercentageBarCellComponent }))
    .service("vTableService", downgradeInjectable(VTableService));

